module.exports = __webpack_public_path__ + "images/data9.png";